export default __webpack_public_path__ + "static/media/2.8c4539d7.jpg";